// extracted by mini-css-extract-plugin
module.exports = {"container":"form-text-area_container__1hMcE","label":"form-text-area_label__16J3d","error":"form-text-area_error__fyePZ"};